import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useIsClient } from '@hivebrite/react-hooks';
import { Box } from '@design-system/box';
import { Slider as DsSlider } from '@design-system/slider';
import { useSliderItems } from './hooks/useSliderItems';
import { TitleBlock } from '../Items/TitleBlock';
const ItemComponentWrapper = ({ as: Component, data }) => (_a) => {
    var { index, onTabKeyDown } = _a, item = __rest(_a, ["index", "onTabKeyDown"]);
    return (_jsx(Component, { data: data, index: index, item: item, onTabKeyDown: onTabKeyDown }));
};
export const BlockSlider = ({ blockId, data, fetchItems, initialItems, initialTotalItems, itemLoader: ItemLoader, itemRenderer: ItemComponent, perPageBreakpoints, pictureHeight, pictureSpace, queryId, setBlockData, shouldDisplay = (input) => isEmpty(input === null || input === void 0 ? void 0 : input['block-filters']) && isEmpty(input === null || input === void 0 ? void 0 : input['block-tags']), title, topicId, }) => {
    const isClient = useIsClient();
    const { fetchNextPage, fetchedItems, isError, isLoading, total } = useSliderItems({
        fetchItems,
        initialItems,
        initialTotalItems,
        queryId,
        topicId
    });
    useEffect(() => {
        setBlockData(fetchedItems);
    }, [blockId, fetchedItems, setBlockData]);
    if (!isClient) {
        return null;
    }
    if (!shouldDisplay(data, isLoading) ||
        isError ||
        (!isLoading && total === 0)) {
        return null;
    }
    return (_jsxs(Box, { "data-testid": "block-slider", display: "block", children: [_jsx(TitleBlock, { isLoading: isLoading, itemsSize: total, title: title }), _jsx(Box, { display: "block", mt: 3, children: _jsx(DsSlider, { ItemComponent: ItemComponentWrapper({ as: ItemComponent, data }), items: fetchedItems, loading: isLoading, LoadingItemComponent: ItemLoader, onLoadMore: fetchNextPage !== null && fetchNextPage !== void 0 ? fetchNextPage : undefined, perPageBreakpoints: perPageBreakpoints, pictureHeight: pictureHeight, pictureSpace: pictureSpace, total: total }) })] }));
};
//# sourceMappingURL=index.js.map